import React from 'react';

function VideoElement({ element, isPreviewMode }) {
  const { content, style = {}, isLoading } = element;
  
  const getYoutubeId = (url) => {
    if (!url) return null;
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };
  
  // Show loading indicator if the video is being uploaded
  if (isLoading) {
    return (
      <div className="video-loading-container" style={{
        width: '100%',
        height: '100%',
        backgroundColor: '#000',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white'
      }}>
        <div className="spinner" style={{
          width: '40px',
          height: '40px',
          border: '4px solid rgba(255,255,255,0.3)',
          borderRadius: '50%',
          borderTop: '4px solid white',
          animation: 'spin 1s linear infinite'
        }}></div>
        <div style={{ marginTop: '10px' }}>Uploading video...</div>
      </div>
    );
  }
  
  // Determine if content is a YouTube URL
  const videoId = getYoutubeId(content || '');
  
  // If it's a YouTube video, show YouTube embed
  if (videoId) {
    return (
      <iframe
        width="100%"
        height="100%"
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    );
  }
  
  // If content is a valid URL (Firebase Storage or other remote URL)
  if (content && (content.startsWith('http') || content.startsWith('blob:'))) {
    return (
      <video
        width="100%"
        height="100%"
        controls
        style={{ objectFit: style.objectFit || 'cover' }}
      >
        <source src={content} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    );
  }
  
  // Default placeholder - shows a video player appearance
  return (
    <div style={{
      width: '100%', 
      height: '100%', 
      backgroundColor: '#000',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{
        color: 'white',
        fontSize: '14px',
        position: 'absolute',
        bottom: '10px',
        left: '10px',
        backgroundColor: 'rgba(0,0,0,0.5)',
        padding: '5px 10px',
        borderRadius: '3px'
      }}>
        0:00
      </div>
      
      <div style={{
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        backgroundColor: 'rgba(255,255,255,0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
          <path d="M8 5v14l11-7z" />
        </svg>
      </div>
      
      {!isPreviewMode && (
        <input 
          type="file" 
          accept="video/*"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            opacity: 0,
            cursor: 'pointer'
          }}
          onClick={(e) => e.stopPropagation()}
        />
      )}
    </div>
  );
}

export default VideoElement; 